var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.getRecords()
                },
              },
            },
            [
              _c("div", { staticClass: "flex mb-1 flex_gap_10" }, [
                _c("div", { staticClass: "form-group mb-0" }, [
                  _c("label", [_vm._v("Поиск по названию")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filter.title,
                        expression: "filter.title",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Препарат" },
                    domProps: { value: _vm.filter.title },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.filter, "title", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group mb-0" }, [
                  _c("label", [_vm._v("Наличие склада до")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filter.sb,
                        expression: "filter.sb",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", placeholder: "10" },
                    domProps: { value: _vm.filter.sb },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.filter, "sb", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group mb-0" }, [
                  _c("label", [_vm._v("Мин. цена")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filter.mp,
                        expression: "filter.mp",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", placeholder: "2000" },
                    domProps: { value: _vm.filter.mp },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.filter, "mp", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group mb-0" }, [
                  _c("label", [_vm._v("Дефицит")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.def,
                          expression: "filter.def",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.filter,
                            "def",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "-1" } }, [
                        _vm._v("Все значения"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("Только дефицит"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "0" } }, [
                        _vm._v("Только не дефицит"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group mb-0" },
                  [
                    _c("label", [_vm._v("Показать с задачами")]),
                    _vm._v(" "),
                    _c(
                      "multiselect",
                      {
                        attrs: {
                          name: "user_role",
                          options: Object.values(_vm.tasksType),
                          placeholder: "Выберите задачи",
                          "track-by": "title",
                          label: "title",
                          showLabels: false,
                          searchable: true,
                          multiple: true,
                        },
                        model: {
                          value: _vm.selectedTasks,
                          callback: function ($$v) {
                            _vm.selectedTasks = $$v
                          },
                          expression: "selectedTasks",
                        },
                      },
                      [
                        _c("template", { slot: "noResult" }, [
                          _vm._v("Тип задачи не найден"),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex justify-content-end ml-2 flex-grow-1" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Показать",
                        loading: _vm.loading,
                        color: _vm.$constants.SUCCESS_COLOR,
                        type: "submit",
                        onClick: () => {},
                        className: "btn btn-outline-success align-self-start",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "form-check" }, [
                  _c("label", { staticClass: "pointer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.hid,
                          expression: "filter.hid",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "radio" },
                      domProps: {
                        value: 3,
                        checked: _vm._q(_vm.filter.hid, 3),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.filter, "hid", 3)
                        },
                      },
                    }),
                    _vm._v(
                      "\n              Показывать только активные, без ветеринарных\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("label", { staticClass: "pointer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.hid,
                          expression: "filter.hid",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "radio" },
                      domProps: {
                        value: 0,
                        checked: _vm._q(_vm.filter.hid, 0),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.filter, "hid", 0)
                        },
                      },
                    }),
                    _vm._v(
                      "\n              Показывать только активные\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("label", { staticClass: "pointer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.hid,
                          expression: "filter.hid",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "radio" },
                      domProps: {
                        value: 4,
                        checked: _vm._q(_vm.filter.hid, 4),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.filter, "hid", 4)
                        },
                      },
                    }),
                    _vm._v(
                      "\n              Показывать только активные ветеринарные\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("label", { staticClass: "pointer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.hid,
                          expression: "filter.hid",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "radio" },
                      domProps: {
                        value: 1,
                        checked: _vm._q(_vm.filter.hid, 1),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.filter, "hid", 1)
                        },
                      },
                    }),
                    _vm._v("\n              Показывать все\n            "),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.paginator
            ? _c(
                "div",
                { staticClass: "flex justify-content-between mt-2" },
                [
                  _c("div", [
                    _vm._v("Всего препаратов: "),
                    _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
                  ]),
                  _vm._v(" "),
                  _c("paginate", {
                    ref: "Pagination",
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 11,
                      "margin-pages": 2,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _c("Table003Stats", {
            ref: "allRecords",
            attrs: {
              paginator: _vm.paginator,
              refreshList: (sortAlias) =>
                _vm.getRecords(1, false, null, sortAlias),
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.paginator
                ? _c("paginate", {
                    ref: "Pagination",
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 11,
                      "margin-pages": 2,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }